export default {
    NENHUMA: 1,
    UMA: 2,
    DUAS: 3,
    TRES: 4,
    QUATRO: 5,
}